import { CatListItem, CatHeading } from 'components/blocks-components';
import { EquipmentName } from '@cat-ecom/pcc-components/src/components/my-equipment/my-equipment-list';
import { Conditional, TextHighlight } from '@cat-ecom/pcc-components';
import { Image } from 'components/image';
import { getProductName } from '@cat-ecom/common/utils/stringUtils';
import { getFamilyName } from 'services/equipment/utils';
import { EquipmentListItemProps } from '../../types';
import styles from '../request-equipment-service-search.module.scss';
import { EQUIPMENT_IMAGE } from 'components/request-equipment-service/constant';

const EquipmentListItem = ({
  item,
  searchTerm,
  onEquipmentSelect
}: EquipmentListItemProps) => {
  const equipmentFamily = getFamilyName(
    item.model,
    item.name ?? item.productFamily
  );
  const trainCaseEquipmentFamily: string = getProductName(equipmentFamily);
  const equipmentName = `${item.model} ${trainCaseEquipmentFamily}`;
  const nickName = item.assetName ?? '';
  const serialNumber = item.serialNumber ?? '';
  const headingVariant = nickName ? 'body-sm' : 'display-sm';

  return (
    <CatListItem
      value={`${item.model} ${equipmentFamily}`}
      onClick={() => onEquipmentSelect(item)}
    >
      <div className={`d-flex ${styles['list-item-container']}`}>
        <Image
          src={item.imageURL && `${item.imageURL}`}
          height={EQUIPMENT_IMAGE.HEIGHT}
          width={EQUIPMENT_IMAGE.WIDTH}
          loading="lazy"
          alt={`${item.model} ${equipmentFamily}`}
          className={`${styles['img--border']}`}
        />
        <div className="ps-2 align-content-around">
          <div>
            <Conditional test={!!nickName}>
              <EquipmentName
                variant="display-sm"
                text={nickName}
                textToHighlightTerm={searchTerm}
                textColor="u-color--Black"
                isVirtualScroll
              />
            </Conditional>
          </div>
          <div>
            <Conditional test={!!equipmentName}>
              <EquipmentName
                variant={headingVariant}
                text={equipmentName}
                textToHighlightTerm={searchTerm}
                textColor="u-color--Black"
                isVirtualScroll
              />
            </Conditional>
          </div>
          <CatHeading variant="body-sm">
            <TextHighlight
              text={serialNumber}
              textToHighlight={searchTerm}
              highlightClassName="text-truncate d-block m-0 u-color--Black"
              isVirtualScroll
            />
          </CatHeading>
        </div>
      </div>
    </CatListItem>
  );
};

export default EquipmentListItem;
